import template from './configureCustomer.html';
import controller from './configureCustomer.controller';

let configureCustomerComponent = {
  restrict: 'E',
  bindings: {
    customerId: '@',
    customerName: '@'
  },
  template,
  controller,
  controllerAs: 'vm'
};

export default configureCustomerComponent;



// WEBPACK FOOTER //
// ./app/components/configureCustomer/configureCustomer.component.js